var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 55,
    viewBox: "0 0 37 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4783 4.93C21.4783 10.03 23.6783 14.23 26.9783 17.83C29.0783 20.13 31.5783 22.03 33.8783 24.13C34.4783 24.63 35.1783 25.03 35.6783 25.63C37.0783 27.23 36.6783 29.23 34.7783 30.23C34.1783 30.53 33.5783 30.63 32.9783 30.93C25.8783 33.83 20.6783 38.53 18.9783 46.43C18.6783 47.73 18.3783 48.93 18.0783 50.13C17.8783 50.93 17.5783 51.83 17.2783 52.63C16.8783 53.73 16.0783 54.53 14.7783 54.43C13.4783 54.33 12.7783 53.53 12.4783 52.33C12.0783 50.83 11.7783 49.23 11.3783 47.63C10.3783 43.53 9.37826 39.43 7.37826 35.63C6.07826 33.03 4.37826 30.83 1.87826 29.13C-0.521739 27.53 -0.621739 25.53 1.57826 23.63C3.37826 22.13 5.47826 20.83 7.37826 19.43C11.8783 16.13 14.4783 11.73 14.8783 6.03C15.0783 5.13 15.0783 3.93 15.2783 2.73C15.4783 0.43 15.7783 0.13 17.7783 0.03C19.7783 -0.17 20.8783 0.63 21.2783 2.43C21.4783 3.23 21.3783 4.13 21.4783 4.93Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg29);
export default __webpack_public_path__ + "static/media/29.41fa1b4f02135080c0c590b48a670fca.svg";
export { ForwardRef as ReactComponent };